import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Reveal } from "../components/site/Motion";
import { TrustSection } from "../components/site/TrustSection";
import { useSettings } from "../lib/settings";
import { DIVISIONS } from "../lib/api";
import { Leadership } from "../components/site/Leadership";
import { OurStory, Timeline, Commitments, ClientsMotivation, Vision } from "../components/site/CompanyStory";

const VALUES = ["Honesty and integrity", "Professionalism", "Transparency", "Customer satisfaction", "Accountability", "Reliable communication", "Long-term business relationships"];

export default function About() {
  const s = useSettings();
  return (
    <div data-testid="about-page">
      <PageHero eyebrow="About Us · Established 2024" title={["Sourcing built on", "straight answers."]} intro="An asset sourcing and brokerage company, established in 2024, helping clients source trucks, trailers, marine vessels and equipment with confidence." testid="about-hero" />
      <OurStory mission={s.mission} />
      <div className="max-w-7xl mx-auto px-5 md:px-10 -mt-10 pb-20 flex flex-wrap gap-4">
        <Link to="/sourcing" className="btn-gold" data-testid="about-sourcing-button">Request an Asset <ArrowRight className="w-4 h-4" /></Link>
        <Link to="/contact" className="btn-ghost" data-testid="about-contact-button">Contact Us</Link>
      </div>
      <Timeline />
      <Leadership />
      <Commitments />
      <ClientsMotivation />
      <section className="py-24 md:py-28 border-t hairline bg-[var(--ink-2)]" data-testid="about-values">
        <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-4">
            <p className="eyebrow">Company values</p>
            <h2 className="font-display text-5xl mt-5 leading-[1]">What we <em>stand on.</em></h2>
          </Reveal>
          <ol className="lg:col-span-8 grid sm:grid-cols-2 border-t hairline">
            {VALUES.map((v, i) => (
              <Reveal key={v} as="li" delay={(i % 2) * 0.06} className="flex items-baseline gap-5 py-5 border-b hairline sm:odd:pr-8">
                <span className="font-mono text-xs text-gold">0{i + 1}</span>
                <span className="font-display text-2xl text-slate-100">{v}</span>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>
      <section className="py-24 md:py-28 border-t hairline">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Reveal><p className="eyebrow mb-8">Four specialized divisions</p></Reveal>
          <Reveal className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border hairline">
            {DIVISIONS.map((d, i) => (
              <Link key={d.key} to={`/divisions/${d.key}`} className="bg-[var(--ink)] p-6 group" data-testid={`about-division-${d.key}`}>
                <span className="font-mono text-xs text-gold">0{i + 1}</span>
                <p className="font-display text-2xl mt-3 group-hover:text-gold transition-colors">{d.name}</p>
                <p className="text-sm text-slate-300 mt-2">{d.blurb}</p>
              </Link>
            ))}
          </Reveal>
        </div>
      </section>
      <Vision />
      <TrustSection />
    </div>
  );
}
